import type { ReactNode } from "react";

/**
 * Marks a route's committed loading branch without changing its layout or accessibility tree.
 *
 * `active={false}` renders the same tree without the marker. A page whose loading and loaded
 * returns must keep one tree (so focus on its h1 survives the record arriving) wraps the loaded
 * return too: otherwise the wrapper's own element type differs between them and React remounts
 * everything beneath it.
 */
export function RoutePending({ children, active = true }: { children: ReactNode; active?: boolean }) {
  return (
    <>
      <span hidden data-route-pending={active ? "true" : undefined} />
      {children}
    </>
  );
}
